var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalIssuesLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.648 0-3.82.023A.32.32 0 0 0 7.5.352v.773c0 .188.14.352.328.352l1.734-.07.047.046-6.539 6.54a.355.355 0 0 0-.093.187c0 .07.046.164.093.21l.54.54a.35.35 0 0 0 .21.093c.047 0 .14-.046.188-.093l6.539-6.54.047.047-.07 1.735c0 .187.164.328.351.328h.773a.32.32 0 0 0 .329-.328L12 .352A.36.36 0 0 0 11.648 0zm-1.523 6.75H9.75a.385.385 0 0 0-.375.375v3.61c0 .093-.07.14-.14.14h-7.97c-.093 0-.14-.047-.14-.14v-7.97c0-.07.047-.14.14-.14h3.61a.385.385 0 0 0 .375-.375v-.375a.403.403 0 0 0-.375-.375h-3.75C.492 1.5 0 2.016 0 2.625v8.25A1.11 1.11 0 0 0 1.125 12h8.25c.61 0 1.125-.492 1.125-1.125v-3.75a.403.403 0 0 0-.375-.375z",
    fill: "#276EF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalIssuesLinkIcon);
export default __webpack_public_path__ + "static/media/external-issues-link-icon.60154862fec24d702bd47d1023acccb5.svg";
export { ForwardRef as ReactComponent };